/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { ProductConstants } from '../actions/actionType';

export function Calculation(state = {}, action) {
    switch (action.type) {
    case ProductConstants.CART_CALCULATION_SUCCESS:
        return {
            type: ProductConstants.CART_CALCULATION_SUCCESS,
            items: action.user.data.data.cart_items,
            summary:action.user.data.data.summary
        };
    case ProductConstants.CART_CALCULATION_FAILURE:
        return {
            type: ProductConstants.CART_CALCULATION_SUCCESS,
            message: action.message,
        };
    case ProductConstants.CART_SELECTED_ITEM:
        return {...state,
            selected:action.user.data
                
        };
        
    default:
        return state;
    }
}
